export default class User {
  id = 0
  name = ''
  position = 0
  primaryBranchId = ''
  branch = ''
  method = ''
  branchName = ''
  state = ''

  constructor (rawData = {}) {
    if (rawData.item_id !== null) {
      this.id = rawData.item_id
      this.name = rawData.item_name
      this.position = rawData.C_user_position_item_id
      this.primaryBranchId = rawData.C_branch_item_id_primary
      this.branch = rawData.C_user_position_item_name
      this.method = rawData.method
      this.branchName = rawData.branch_name
      this.state = rawData.state
    }
  }

  get hasPrimaryBranchId () {
    return (this.primaryBranchId !== null && this.primaryBranchId !== undefined && this.primaryBranchId !== '')
  }
}
